import { defineComponent as _defineComponent } from 'vue'
import CoursesComponent from "@/components/courses-component.vue";
import CalendarComponent from "@/components/calendar-component.vue";
import TodaysScheduleComponent from "@/components/todays-schedule-component.vue";
import NoticeBoardDisplayComponent from "@/components/notice-board-display.vue";

// @ts-ignore
import CoolLightBox from "vue-cool-lightbox";
import LiveLectureAttendanceStatsChart from "@/components/live-lecture-attendance-stats-chart.vue";
import BrowserNotSupportedWarningDialog from "@/components/dialogs/browser-not-supported-warning-dialog.vue";
import { isBrowserSupported } from "@/helpers/isBrowserSupported";
import UpcomingLecture from "@/interfaces/upcomingLecture.interface";
import StudentSemesterCourseUnit from "@/interfaces/studentSemesterCourseUnit.interface";
import store from "@/store";

import { onMounted, ref, Ref } from "vue";
import useHttpRequest from "@/composables/use-http-request";


export default /*#__PURE__*/_defineComponent({
  __name: 'home',
  setup(__props) {

// import "vue-cool-lightbox/dist/vue-cool-lightbox.min.css";
const loading = ref(false);
const browserNotSupportedWarningDialogVisible = ref(false);

const dayToday = ref(0);
const calendarMonth: Ref<number | undefined> = ref();
const calendarYear: Ref<number | undefined> = ref();

const upcomingLectures = ref<UpcomingLecture[]>([]);
const courseUnits = ref<StudentSemesterCourseUnit[]>([]);
const notices: Ref<{ title: string; message: string }[]> = ref([]);
const eventDays = ref<number[]>([]);

const carouselKey = ref(0);
const index = ref<number | null>(null);

const items = [
  "https://victoria-university-elearning.s3.amazonaws.com/vu_payment_images/Direct+Bank+payments.jpg",
  "https://victoria-university-elearning.s3.amazonaws.com/vu_payment_images/Flexipay.jpg",
  "https://victoria-university-elearning.s3.amazonaws.com/vu_payment_images/Mobile+and+Online+payments.jpg",
  "https://victoria-university-elearning.s3.amazonaws.com/vu_payment_images/Mobile+payments.jpg",
  "https://victoria-university-elearning.s3.amazonaws.com/vu_payment_images/Fees+Payment+options.jpg",
];

const checkIfBrowserIsSupported = () => {
  if (!isBrowserSupported()) {
    browserNotSupportedWarningDialogVisible.value = true;
  }
};

const fetchStudentData = async () => {
  const request = await useHttpRequest<{
    success: boolean;
    message: string;
    date_today: string;
    days: number[];
    notices: { title: string; message: string }[];
    course_units: StudentSemesterCourseUnit[];
    upcoming_lectures: UpcomingLecture[];
  }>({
    method: "GET",
    url: `students/fetch-dashboard-home/${store.state.userId}`,
    loadingProperty: loading,
    showSuccessMessage: false,
  });

  if (!request) return;
  if (
    request.success &&
    request.message == "DASHBOARD_CONTENT_FETCHED_SUCCESSFULLY"
  ) {
    const today = request.date_today.split("-");
    eventDays.value = request.days;
    calendarYear.value = +today[0];
    calendarMonth.value = +today[1];
    dayToday.value = +today[2];
    upcomingLectures.value = request.upcoming_lectures;
    notices.value = request.notices;
    courseUnits.value = request.course_units;
    ++carouselKey.value;
  }
};

onMounted(() => {
  checkIfBrowserIsSupported();
  fetchStudentData();
});

return { __sfc: true,loading, browserNotSupportedWarningDialogVisible, dayToday, calendarMonth, calendarYear, upcomingLectures, courseUnits, notices, eventDays, carouselKey, index, items, checkIfBrowserIsSupported, fetchStudentData, CoursesComponent, CalendarComponent, TodaysScheduleComponent, NoticeBoardDisplayComponent, CoolLightBox, LiveLectureAttendanceStatsChart, BrowserNotSupportedWarningDialog }
}

})